// extracted by mini-css-extract-plugin
export var borderRadius = "_5w-4";
export var large = "_5w-3";
export var logoContainer = "_5w-0";
export var nameLogo = "_5w-2";
export var small = "_5w-1";